var Preloader = {
    start: function() {
        var $preloader = $('.preloader');
        if (!$preloader.length) {
            $('body').prepend('<div class="preloader"><span class="preloader-text"><i></i>Loading ...</span></div>');
        }
        var $preloader = $('.preloader');
        $preloader.fadeIn('slow');
    },
    end: function() {
        if ($('.preloader').length){
            $('.preloader').delay(100).fadeOut(50);
        }
    }        
};

export default Preloader;